<template>
  <div class="flex flex-col">
    <div class="my-2 -mx-4 overflow-x-auto sm:-mx-6 2xl:-mx-8 ">
      <div class="inline-block min-w-full py-2 align-middle sm:px-6 2xl:px-8">
        <div class="overflow-hidden shadow ring-1 ring-black ring-opacity-5 sm:rounded-lg">
          <table class="min-w-full divide-y divide-gray-300">

            <thead class="bg-gray-50 divide-y ">
              <template v-if="hasChildren">
                <template  v-for="(column, index) in header">
                  <colgroup v-if="index in itemsWithChildren" :key="`${column.title}_${index}`" :span="header[index].length"/>
                  <col v-else :key="column.title"/>
                </template>
              </template>
              <tr class="divide-x">
                <template v-for="column in header">
                  <th v-if="column.children === undefined" :rowspan="hasChildren ? 2 : 1" :key="column.title" class="px-3 py-3.5 text-center 2xl:text-sm sm:text-xl font-semibold text-gray-600">
                    {{ column.title}}
                  </th>
                  <th v-else :key="column.title" :colspan="column.children.length" class="px-3 py-3.5 text-center 2xl:text-sm sm:text-xl font-semibold text-gray-600">
                    {{ column.title}}
                  </th>
                </template>
              </tr>
              <template v-if="hasChildren">
                <tr class="" >
                  <template v-for="(children, index) in childrens">
                    <th :key="`${children.title}_${index}`" class="border border-inherit px-3 py-3.5 text-center 2xl:text-sm sm:text-xl font-semibold text-gray-600" scope="col">{{children.title}}</th>
                  </template>
                </tr>
              </template>

            </thead>
            <tbody class="divide-y divide-gray-200 bg-white">
              <tr :class="`${record.bgcolor}`" v-for="record in records" :key="record.id.value">
                <template v-for="column in headerProcesed">

                  <td v-if="get_of_key(get_of_key(record, column.key, {}), 'renderer') === 'link'" :key="column.key" class="whitespace-nowrap px-3 py-4 2xl:text-sm sm:text-xl text-gray-500">
                      <a href="#" @click="linkClicked(record[column.key])" class="text-indigo-600 hover:text-indigo-900">{{ record[column.key].label }}</a>
                  </td>
                  <td v-else-if="get_of_key(get_of_key(record, column.key, {}), 'type') === 'action'"  :key="column.key" class="whitespace-nowrap px-3 py-4 2xl:text-sm sm:text-xl text-gray-500">
                      <template v-for="action in record[column.key].value">
                        <a :key="`${column.key}_${action.label}`"
                          href="#"
                          @click="runAction(record, action)"
                          class="text-indigo-600 hover:text-indigo-900 m-1">
                          {{ action.label }}
                        </a>
                      </template>
                  </td>
                  <!-- <td v-else-if="typeof " :key="column.key" class="whitespace-nowrap px-3 py-4 2xl:text-sm sm:text-xl text-gray-500">{{ record[column.key] }}</td> -->
                  <td v-else :key="column.key" class="whitespace-nowrap px-3 py-4 2xl:text-sm sm:text-xl text-gray-500">{{ record[column.key] }}</td>
                  <!-- <td v-else :key="column.key" class="whitespace-nowrap px-3 py-4 2xl:text-sm sm:text-xl text-gray-500">{{ get_of_key(get_of_key(record, column.key, {}), 'value') }}</td> -->

                </template>

                <template v-if="field.actions !== false">
                  <td class="relative whitespace-nowrap py-4 pl-3 pr-4 text-right 2xl:text-sm sm:text-xl font-medium sm:pr-6">
                    <a @click="removeRecord(record.id)" class="text-indigo-600 hover:text-indigo-900">Eliminar</a>
                  </td>
                  <td class="relative whitespace-nowrap py-4 pl-3 pr-4 text-right 2xl:text-sm sm:text-xl font-medium sm:pr-6">
                    <a @click="editRecord(record.id)" class="text-indigo-600 hover:text-indigo-900">Editar</a>
                  </td>
                </template>
              </tr>

              <!-- More people... -->
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'table-field',

  data() {
    return {
      header: [{}],
      records: [],
      dependentdata: {},
      childrens: [],
      hasChildren: false,
      itemsWithChildren: [],
      headerProcesed: []
    }
  },
  props: {
    field: {
      type: Object,
      required: true
    },
    formdata: {
      type: Object,
      required: true
    }
  },
  created() {
    this.getTable()
    this.checkDepends()
  },
  watch: {
    formdata: {
      deep: true,
      handler: async function(newVal)  {
        if (this.field.depends !== '' && this.field.depends !== undefined) {
          if ( typeof this.dependentdata[this.field.depends] === 'object'){
            if (this.field.depends in newVal) {
              if (JSON.stringify(this.dependentdata[this.field.depends]) !== JSON.stringify(newVal[this.field.depends])) {
                this.dependentdata[this.field.depends] = JSON.parse(JSON.stringify(newVal[this.field.depends]))
                this.getRecords()
              }
            }
          }else {
            if (this.field.depends in newVal) {
              if (this.dependentdata[this.field.depends] !== newVal[this.field.depends]) {
                this.dependentdata[this.field.depends] = JSON.parse(JSON.stringify(newVal[this.field.depends]))
                this.getRecords()
              }
            }
          }
        }
      }
    },
  },
  methods: {
    checkDepends() {
      if (this.field.depends === undefined || this.field.depends === "") {
        this.getRecords()
      }
    },
    async getTable() {
      let config = {
        params: {
          ...this.$store.state.data,
          table: this.field.key,
          blueprint: this.$route.params.blueprint,
          formdata: this.formdata,
          query: this.$route.query
        }
      }
      const response = await this.$http.get(this.field.uri, config)
      this.checkChildren(response.data)
      this.header = response.data

    },
    async getRecords() {
      let config = {
        params: {
          ...this.$store.state.data,
          id: this.$route.params.record,
          table: this.field.key,
          blueprint: this.$route.params.blueprint,
          formdata: this.formdata,
          query: this.$route.query
        }
      }
      const tableresponse = await this.$http.get(`/flow/custom/` + this.field.key, config)
      this.records = tableresponse.data
    },
    checkChildren(header){
      this.childrens = []
      header.forEach((item, i) => {
        if (typeof item.children !== 'undefined'){
            this.childrens = [...this.childrens, ...item.children.map(x => x)]
            this.headerProcesed = [...this.headerProcesed, ...item.children]
            this.itemsWithChildren = [...this.itemsWithChildren, i]
            this.hasChildren = true
          } else{
          this.headerProcesed = [...this.headerProcesed, item]
        }
      })
    },
    async linkClicked(link) {
      this.$router.push(link.url)
      this.$router.go()
    },
    async removeRecord(recordid) {
      let config = {
        params: {
          ...this.$store.state.data,
          blueprint: this.$route.params.blueprint,
          record: this.$route.params.record,
          recordid: recordid
        }
      }
      const response = await this.$http.get(`/flow/custom/removerecord`, config)
      console.log('removeRecord', response)
      if (response.data.push !== undefined){
        console.log(response.data);
        this.$router.push(response.data.push)
        this.$router.go()
      }else{
        this.getRecords()
      }
    },
    goToForm(record, action){
      this.$store.commit('setState', {record: record})
      this.$router.push(action.url)
      this.$router.go()
    },
    async runAction (record, action) {
      if (action.action === 'goToForm'){
        this.goToForm(record, action)
      } else if (action.action === 'runInForm') {
        await this[action.function](record.id)
      } else if (action.action === 'runInApi') {
        this.runInApi(record, action)
      } else {
        console.log("No se ha ejecutado nada");
      }
    },
    async runInApi(record, action){
      console.log('runInApi')
      console.log(record);
      let config = {
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'JWT ' + this.$store.getters.auth.token
        },
        params: {
          ...this.params,
          blueprint: this.$route.params.blueprint,
          record: this.$route.params.record,
          query: {...this.$route.query, ...action.params}
        }
      }
      
      const response = await this.$http.get(action.url, config)
      if (response.data.push !== undefined){
        console.log(response.data);
        this.$router.push(response.data.push)
        this.$router.go()
      }else{
        this.getRecords()
      }
      
    },
    editRecord(recordid) {
      // XXX: Esto está fijo, me parece que es arte de CMPC
      this.$router.push('/form/5/' + recordid)
      this.$router.go()
    },
    get_of_key(obj, key, default_value = undefined){
      const response = (typeof obj[key]!== "undefined") ? obj[key] : default_value
      return response

    },
    validateIsAction(record, column) {
      if (typeof record[column.key] !== undefined){
        if (record[column.key].type === 'action'){
          return true
        }
      }
      return false
    }

  }
}
</script>
